// DEPENDENCIES
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { useFormik } from "formik";
// COMPONENTS
import DataTable from 'react-data-table-component';
import MaskedInput from 'react-maskedinput';
import Select from 'react-select';
import { Link, useParams } from 'react-router-dom';
// ICONS
// CUSTOM COMPONENTS
import { Modal } from 'react-bootstrap';
import Section from '../../../../components/Section';
import ContentBlock from '../../../../components/ContentBlock';
import CustomBlock from '../../../../components/CustomBlock';
import ContentHeader from '../../../../components/ContentHeader';
import InputBlock from '../../../../components/InputBlock';
import SelectBlock from '../../../../components/SelectBlock';
import Button from '../../../../components/Button';
// PARTIALS
// SERVICES AND HELPERS
import LeadTCLPDataSheetValidator from '../../../../../helpers/validators/LeadTCLPDataSheetValidator';
import LeadTCLPDataSheetLineItemValidator from '../../../../../helpers/validators/LeadTCLPDataSheetLineItemValidator';
import * as leadTCLPDataSheetService from '../../../../../services/form/leadTCLPDataSheetService';
import * as alert from '../../../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../../../redux/confirmModalRedux';
import * as jobFormService from '../../../../../services/service/jobFormService';
import * as helper from '../../../../../helpers/helper';
import * as weatherService from '../../../../../services/weatherService';
import * as leadTCLPChainOfCustodyService from '../../../../../services/form/leadTCLPChainOfCustodyService';

const initialState = {
    id: 0,
    projectLocationId: null,
    analyzedBy: '',
    leadTCLPDataSheetLineItems: []
}

const lineItemInitialState = {
    id: 0,
    sampleNumber: '',
    colorDescription: '',
    location: '',
    matrix: '',
    resultsPercentageWeight: '',
    resultsPercentageWeightOperator: '',
}

const LeadTCLPDataSheetForm = (props) => {
    const iframeRef = useRef();
    const { jobFormId, edit } = useParams();
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, history, auth } = props;
    const [loading, setLoading] = useState(false);
    const [leadTCLPDataSheet, setLeadTCLPDataSheet] = useState(initialState);
    const [locationOptions, setLocationOptions] = useState([]);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [isFetchingWeather, setIsFetchingWeather] = useState(false);
    const [lineItemModel, setLineItemModel] = useState(lineItemInitialState);
    const [showExtra, setShowExtra] = useState(false);
    const [switchMode, setSwitchMode] = useState(false);
    const [weatherCity, setWeatherCity] = useState("");
    const [selectedOptions, setSelectedOptions] = useState({
        projectLocationId: null,
        analyzedBy: null,
        matrix: null
    })
    const [jobForm, setJobForm] = useState({
        id: 0,
        jobFormId: 0,
        projectNumber: "",
        client: "",
        name: "Lead TCLP Data Sheet",
        actualAssignedDate: null,
        submittedById: 0,
        jobId: 0,
        formLead: '',
        project: '',
        leadTCLPChainOfCustodyId: null,
        LeadTCLPChainOfCustodyJobFormId: null
    });
    const [lineItemOptions, setLineItemOptions] = useState({
        resultsPercentageWeightOperator: ['< ']
    })
    const [lineItemSelectedOptions, setLineItemSelectedOptions] = useState({
        resultsPercentageWeightOperator: ''
    })
    const [options, setOptions] = useState({
        analyzedBy: ['AES', 'CA Labs', 'EMSL'],
    })

    useEffect(() => {
        setLoading(true);

        if (edit == 'false') {
            setSwitchMode(true)
            getReport(jobFormId)
        }
        else {
            fetchJobLocations().then(locations => {
                fetchLeadTCLPDataSheet(locations)
            });
        }

    }, []);

    const getReport = (id) => {
        if (id) {
            leadTCLPDataSheetService.getReportPdf(id).then(res => {
                iframeRef.current.src = "data:application/pdf;base64," + res;
            }).catch(ex => {
            })
        }
    }

    const fetchJobLocations = () => jobFormService.getProposalProjectLocationsByJobFormId(jobFormId).then(res => {
        setLocationOptions(res);
        return res;
    });

    const fetchLeadTCLPDataSheet = (projectLocations) => {
        return leadTCLPDataSheetService.getLeadTCLPDataSheetById(jobFormId).then(res => {
            prefillSavedOptions(res.leadTCLPDataSheet, projectLocations);
            setJobForm(res);
            setIsReadOnly(res.submittedById !== 0);
            delete res.leadTCLPDataSheet.projectLocation;
            setLeadTCLPDataSheet({ ...res.leadTCLPDataSheet });

            return res;
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => setLoading(false));
    }

    const prefillSavedOptions = (model, projectLocations) => {
        let selectedProjectLocation = model.projectLocationId ? projectLocations.find(x => x.value == model.projectLocationId) : null
        setSelectedOptions({
            projectLocationId: selectedProjectLocation,
            analyzedBy: model.analyzedBy ? helper.setToOptionModel(model.analyzedBy, model.analyzedBy) : null,
        })
        if (selectedProjectLocation) {
            setCityAndStateForWeather(selectedProjectLocation.label);
        }
    }

    const setCityAndStateForWeather = (address) => {
        let city = address.split(",");

        if (city.length > 2) {
            setWeatherCity(city[city.length - 2] + ", " + helper.getFullStateName(city[city.length - 1].trim()));
        }
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: leadTCLPDataSheet,
        validationSchema: LeadTCLPDataSheetValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            saveForm(values).finally(() => {
                setLoading(false);
                setSubmitting(false);
            });
        }
    });

    const formik_lineItem = useFormik({
        enableReinitialize: true,
        initialValues: lineItemModel,
        validationSchema: LeadTCLPDataSheetLineItemValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            saveLineItem(values);
        }
    });

    const clearLineItemForm = () => {
        setShowExtra(false);
        formik_lineItem.resetForm();
        setLineItemSelectedOptions({
            resultsPercentageWeightOperator: ''
        });
        setLineItemModel(lineItemInitialState);
    }

    const saveForm = (values) => {
        return leadTCLPDataSheetService.save({ ...values, jobFormId: jobForm.id }).then(res => {
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        })
    }

    const submitForm = () => {
        saveForm(formik.values).then(res => {
            jobFormService.submitForm(jobForm.id).then(res => {
                showAlert({ message: "Success! Lead-TCLP Data Sheet has been submitted.", variant: 'success' });
                history.push("/services/manage-job/forms/" + jobForm.jobId);
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' })
            })
        }).catch(ex => { })
    }

    const discardCOC = () => {
        setProcessing();
        leadTCLPChainOfCustodyService.discardCOC(jobForm.leadTCLPChainOfCustodyId).then(res => {
            showAlert({ message: "Success! Chain Of Custody form has been discarded.", variant: 'success' });
            setJobForm({ ...jobForm, leadTCLPChainOfCustodyId: null })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => {
            hideConfirmModal();
        })
    }

    const generateCOC = () => {
        setProcessing();
        saveForm(formik.values).then(res => {
            leadTCLPChainOfCustodyService.generateLeadTCLPChainOfCustody(leadTCLPDataSheet.id).then(res => {
                showAlert({ message: "Success! Lead-TCLP Chain Of Custody has been generated.", variant: 'success' });
                setJobForm({ ...jobForm, leadTCLPChainOfCustodyId: res.id, leadTCLPChainOfCustodyJobFormId: res.jobFormId })
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' });
            })
        }).catch(ex => { }).finally(() => {
            hideConfirmModal();
        })
    }
    const removeLineItem = (id) => {
        setLoading();
        setProcessing();
        leadTCLPDataSheetService.deleteLineItem(id).then(res => {
            removeFromLineItemTable(id);
            showAlert({ message: res.message, variant: 'success' });
            setShowExtra(false);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => {
            hideConfirmModal();
        })
    }

    const removeFromLineItemTable = (id) => {
        let temp = [...leadTCLPDataSheet.leadTCLPDataSheetLineItems];
        let indexOfEdited = temp.findIndex(x => x.id === id);

        if (indexOfEdited > -1) {
            temp.splice(indexOfEdited, 1);
            setLeadTCLPDataSheet({ ...leadTCLPDataSheet, leadTCLPDataSheetLineItems: temp });
        }
    }


    const saveLineItem = (values) => {
        values = { ...values, dateTime: jobForm.actualAssignedDate, leadTCLPDataSheetId: leadTCLPDataSheet.id }
        leadTCLPDataSheetService.saveLineItem(values).then(res => {
            if (values.id > 0) {
                let temp = [...leadTCLPDataSheet.leadTCLPDataSheetLineItems];
                let indexOfEdited = temp.findIndex(x => x.id === values.id);
                temp[indexOfEdited] = values;
                setLeadTCLPDataSheet({ ...leadTCLPDataSheet, leadTCLPDataSheetLineItems: temp })
            } else {
                values.id = res.id;
                setLeadTCLPDataSheet({ ...leadTCLPDataSheet, leadTCLPDataSheetLineItems: [...leadTCLPDataSheet.leadTCLPDataSheetLineItems, values] })
            }

            clearLineItemForm();
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => setLoading(false))
    }

    const columns = [
        {
            name: "Actions",
            selector: row => row["id"],
            sortable: true,
            width: '160px',
            omit: !auth.isAdmin && isReadOnly,
            cell: row => <CustomBlock className="content-container--actions flex-start pl-0 mt-0">
                <Button
                    text="Edit"
                    className="info--bg ml-0"
                    size="xxs"
                    onClick={() => {
                        var tempLineItemsOptions = { ...lineItemSelectedOptions };
                        tempLineItemsOptions = {
                            ...tempLineItemsOptions,
                            resultsPercentageWeightOperator: { label: row.resultsPercentageWeightOperator, value: row.resultsPercentageWeightOperator }
                        }
                        setLineItemSelectedOptions({ ...tempLineItemsOptions });

                        setLineItemModel(row);
                    }}
                />

                <Button
                    text="Delete"
                    className="danger--bg ml-0"
                    size="xxs"
                    onClick={() => showConfirmModal({
                        title: "Delete Line Item",
                        text: "Are you sure you want to delete this line item?",
                        rightBtnText: "Confirm",
                        btnAction: () => removeLineItem(row.id)
                    })}
                />
            </CustomBlock>

        },
        {
            name: "Sample No.",
            selector: row => row["sampleNumber"],
            sortable: true,
        },
        {
            name: "Waste Stream",
            selector: row => row["colorDescription"],
            sortable: true,
        },
        {
            name: "Location",
            selector: row => row["location"],
            sortable: true,
        },
        // {
        //     name: "Matrix",
        //     selector: row => row["matrix"],
        //     sortable: true,
        // },
        {
            name: "Results %wt",
            selector: row => row["resultsPercentageWeightOperator"] ? row["resultsPercentageWeightOperator"] + row['resultsPercentageWeight'] : row["resultsPercentageWeight"],
            sortable: true,
        }
    ];

    return (
        <>
            {
                switchMode ?
                    (<iframe ref={iframeRef} style={{ height: '100%', width: '100%' }} title="description"></iframe>)
                    :
                    (
                        <>
                            <Section removeContainer>
                                <ContentBlock>
                                    <CustomBlock className="content-container--card-style--with-shadow">
                                        <ContentHeader
                                            title={`Job #${jobForm.projectNumber} Lead-TCLP Data Sheet`}
                                            headerSize="md"
                                            primaryButtonText="Print Form"
                                            primaryButtonBackgroundColor="info--bg mr-0"
                                            primaryButtonOnClick={() => {
                                                setSwitchMode(true);
                                                getReport(jobForm ? jobForm.id : 0)
                                            }}
                                        />

                                        <CustomBlock>
                                            <Section removeContainer className="pb-10">
                                                <ContentBlock>
                                                    <ContentHeader
                                                        title="Header Information"
                                                        headerSize="sm"
                                                        className="fw-700 pb-10"
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Date"
                                                        value={moment(jobForm.actualAssignedDate).format("MM/DD/YYYY")}
                                                        disabled
                                                    />

                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="AES Project #"
                                                        value={jobForm.projectNumber}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Client"
                                                        value={jobForm.client}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Inspector"
                                                        value={jobForm.formLead}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <SelectBlock
                                                        label="Location"
                                                        inputState={formik.touched.projectLocationId && formik.errors.projectLocationId ? "error" : ""}
                                                        errorMessage={formik.errors.projectLocationId}
                                                        value={selectedOptions.projectLocationId}
                                                        options={locationOptions}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedOptions({ ...selectedOptions, projectLocationId: selectedOption });
                                                            formik.setFieldValue("projectLocationId", selectedOption.value);
                                                            if (selectedOption)
                                                                setCityAndStateForWeather(selectedOption.label ? selectedOption.label : "");
                                                        }}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <SelectBlock
                                                        isClearable
                                                        creatableSelect
                                                        label="Analyzed By"
                                                        inputState={formik.touched.analyzedBy && formik.errors.analyzedBy ? "error" : ""}
                                                        errorMessage={formik.errors.analyzedBy}
                                                        value={selectedOptions.analyzedBy}
                                                        options={options.analyzedBy.map(x => helper.setToOptionModel(x, x))}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedOptions({ ...selectedOptions, analyzedBy: selectedOption });
                                                            formik.setFieldValue("analyzedBy", selectedOption.value);
                                                        }}
                                                    />
                                                </ContentBlock>

                                            </Section>
                                            <Section removeContainer className="pt-10 pb-10 border-top">
                                                {(!auth.isAdmin ? !isReadOnly : true) && <>
                                                    <ContentBlock>
                                                        <ContentHeader
                                                            title="Line Item Entry"
                                                            headerSize="sm"
                                                            className="fw-700 pb-15"
                                                            primaryButtonText={lineItemModel.id > 0 ? "Update" : "Add" + " Line Item"}
                                                            primaryButtonOnClick={formik_lineItem.submitForm}
                                                            secondaryButtonText="Clear"
                                                            secondaryButtonOnClick={clearLineItemForm}
                                                        />
                                                    </ContentBlock>

                                                    <ContentBlock cols={3}>
                                                        <InputBlock
                                                            isRequired
                                                            label="Sample No."
                                                            name="sampleNumber"
                                                            id="sampleNumber"
                                                            inputState={formik_lineItem.touched.sampleNumber && formik_lineItem.errors.sampleNumber ? "error" : ""}
                                                            errorMessage={formik_lineItem.errors.sampleNumber}
                                                            {...formik_lineItem.getFieldProps("sampleNumber")}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={5}>
                                                        <InputBlock
                                                            isRequired
                                                            label="Waste Stream"
                                                            name="colorDescription"
                                                            id="colorDescription"
                                                            inputState={formik_lineItem.touched.colorDescription && formik_lineItem.errors.colorDescription ? "error" : ""}
                                                            errorMessage={formik_lineItem.errors.colorDescription}
                                                            {...formik_lineItem.getFieldProps("colorDescription")}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={4}>
                                                        <InputBlock
                                                            isRequired
                                                            label="Location"
                                                            name="location"
                                                            id="location"
                                                            inputState={formik_lineItem.touched.location && formik_lineItem.errors.location ? "error" : ""}
                                                            errorMessage={formik_lineItem.errors.location}
                                                            {...formik_lineItem.getFieldProps("location")}
                                                        />
                                                    </ContentBlock>
                                                    {/* <ContentBlock cols={2}>
                                                        <InputBlock
                                                            isRequired
                                                            label="Matrix"
                                                            name="matrix"
                                                            id="matrix"
                                                            inputState={formik_lineItem.touched.matrix && formik_lineItem.errors.matrix ? "error" : ""}
                                                            errorMessage={formik_lineItem.errors.matrix}
                                                            {...formik_lineItem.getFieldProps("matrix")}
                                                        />
                                                    </ContentBlock> */}
                                                    <ContentBlock cols={4} >
                                                        <div style={{ display: 'flex' }}>
                                                            <SelectBlock
                                                                isClearable
                                                                label="Results w/%"
                                                                placeholder={' '}
                                                                id='resultsPercentageWeightOperator'
                                                                name='resultsPercentageWeightOperator'
                                                                inputState={""}
                                                                value={lineItemSelectedOptions.resultsPercentageWeightOperator}
                                                                options={lineItemOptions.resultsPercentageWeightOperator.map(x => helper.setToOptionModel(x, x))}
                                                                onChange={selectedOption => {
                                                                    selectedOption = selectedOption === null ? [] : selectedOption;
                                                                    setLineItemSelectedOptions({ ...lineItemSelectedOptions, resultsPercentageWeightOperator: selectedOption });
                                                                    formik_lineItem.setFieldValue('resultsPercentageWeightOperator', selectedOption.value);
                                                                }}
                                                            />
                                                            &nbsp;
                                                            <div style={{display:'flex', flexDirection:'column'}}>
                                                                <label className="col-xlg-3 col-xlg-3 col-form-label col-xlg-3 col-xlg-3 col-form-label fz-sm fw-600" style={{paddingBottom: '20px'}}>
                                                                    {' '}
                                                                </label>
                                                                <MaskedInput
                                                                    className="form-control form-control-lg form-control-solid"
                                                                    mask="11.1111%"
                                                                    {...formik_lineItem.getFieldProps("resultsPercentageWeight")}
                                                                />
                                                                {formik_lineItem.touched.resultsPercentageWeight && formik_lineItem.errors.resultsPercentageWeight ? (
                                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                                        {formik_lineItem.errors.resultsPercentageWeight}
                                                                    </div>
                                                                ) : null}
                                                            </div>

                                                        </div>

                                                    </ContentBlock>


                                                </>}
                                                <ContentBlock>
                                                    <CustomBlock className="content-container--table-container">
                                                        <ContentHeader
                                                            title="Sample Line Items"
                                                            headerSize="md"
                                                            className="fw-700 dark-grey--clr pt-10"
                                                        />
                                                        <DataTable
                                                            columns={columns}
                                                            data={leadTCLPDataSheet.leadTCLPDataSheetLineItems}
                                                            pagination
                                                            subHeader
                                                            subHeaderAlign="left"
                                                        />
                                                    </CustomBlock>
                                                </ContentBlock>
                                            </Section>

                                            {!auth.isAdmin ?
                                                !isReadOnly &&
                                                <Section removeContainer className="pt-10">
                                                    <ContentBlock className="content-container--actions">
                                                        <Button
                                                            text="Save Changes"
                                                            className="warning--bg"
                                                            onClick={formik.handleSubmit}
                                                        />
                                                        {
                                                            jobForm.leadTCLPChainOfCustodyId ?
                                                                <>
                                                                    <Button
                                                                        text="Discard COC"
                                                                        onClick={() =>
                                                                            showConfirmModal({
                                                                                title: "Discard Chain Of Custody",
                                                                                text: "Are you sure you want to discard the current Chain Of Custody for this datasheet?",
                                                                                rightBtnText: "Confirm",
                                                                                btnAction: () => discardCOC()
                                                                            })
                                                                        }
                                                                        className="danger--bg"
                                                                    />

                                                                    <Button
                                                                        text="View COC"
                                                                        to={"/forms/lead-TCLP-coc/" + jobForm.leadTCLPChainOfCustodyJobFormId + '/true'}
                                                                        className="info--bg"
                                                                    />
                                                                </>
                                                                :
                                                                <Button
                                                                    text="Generate COC"
                                                                    onClick={() =>
                                                                        showConfirmModal({
                                                                            title: "Generate Chain Of Custody",
                                                                            text: "Are you sure you want to generate a Chain Of Custody for this datasheet?",
                                                                            rightBtnText: "Confirm",
                                                                            btnAction: () => generateCOC()
                                                                        })
                                                                    }
                                                                    className="info--bg"
                                                                />
                                                        }
                                                        <Button
                                                            text="Submit Form"
                                                            onClick={submitForm}
                                                            className="success--bg"
                                                        />
                                                    </ContentBlock>
                                                </Section>
                                                :
                                                <Section removeContainer className="pt-10">
                                                    <ContentBlock className="content-container--actions">
                                                        <Button
                                                            text="Save Changes"
                                                            className="warning--bg"
                                                            onClick={formik.handleSubmit}
                                                        />
                                                        {
                                                            jobForm.leadTCLPChainOfCustodyId ?
                                                                <>
                                                                    <Button
                                                                        text="Discard COC"
                                                                        onClick={() =>
                                                                            showConfirmModal({
                                                                                title: "Discard Chain Of Custody",
                                                                                text: "Are you sure you want to discard the current Chain Of Custody for this datasheet?",
                                                                                rightBtnText: "Confirm",
                                                                                btnAction: () => discardCOC()
                                                                            })
                                                                        }
                                                                        className="danger--bg"
                                                                    />

                                                                    <Button
                                                                        text="View COC"
                                                                        to={"/forms/lead-TCLP-coc/" + jobForm.leadTCLPChainOfCustodyJobFormId + '/true'}
                                                                        className="info--bg"
                                                                    />
                                                                </>
                                                                :
                                                                <Button
                                                                    text="Generate COC"
                                                                    onClick={() =>
                                                                        showConfirmModal({
                                                                            title: "Generate Chain Of Custody",
                                                                            text: "Are you sure you want to generate a Chain Of Custody for this datasheet?",
                                                                            rightBtnText: "Confirm",
                                                                            btnAction: () => generateCOC()
                                                                        })
                                                                    }
                                                                    className="info--bg"
                                                                />
                                                        }
                                                        {
                                                            !isReadOnly &&
                                                            <Button
                                                                text="Submit Form"
                                                                onClick={submitForm}
                                                                className="success--bg"
                                                            />
                                                        }
                                                    </ContentBlock>
                                                </Section>
                                            }
                                        </CustomBlock>
                                    </CustomBlock>
                                </ContentBlock>
                            </Section>
                        </>
                    )
            }
        </>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, {
    ...alert.actions,
    ...confirmModal.actions
})(LeadTCLPDataSheetForm);